export const DAY_START = 0;
export const DAY_END = 24;
export const HOUR_HEIGHT = 56;
// The week calendar's time scale is chosen from a set of slot sizes (in
// minutes) rather than a free zoom. Every slot row is SLOT_PX tall regardless
// of the chosen size, so picking a finer slot just adds more rows and makes the
// day taller. Ordered coarse -> fine.
export const SLOT_PX = 60;
export const SLOT_MINUTE_OPTIONS = [60, 30, 15, 5];
export const DEFAULT_SLOT_MINUTES = 30;
// Minimum rendered height (px) for an entry/draft so very short ones stay
// grabbable, without scaling with the (variable) hour height.
export const MIN_ENTRY_PX = 16;
// Moving/resizing an entry always snaps to this fine grid, regardless of the
// chosen slot size.
export const DRAG_SNAP_MINUTES = 5;

export function snap(hour) {
  return Math.round(hour * 4) / 4;
}

export function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
